import { render } from "./FileMessage.vue?vue&type=template&id=702cbd6c&scoped=true&ts=true"
import script from "./FileMessage.vue?vue&type=script&lang=ts"
export * from "./FileMessage.vue?vue&type=script&lang=ts"

import "./FileMessage.vue?vue&type=style&index=0&id=702cbd6c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702cbd6c"]])

export default __exports__